module.exports = __webpack_public_path__ + "img/kort4.a10ffec2.jpg";